"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerVerifyAccount = void 0;
const React = require("react");
const react_1 = require("react");
const Form_1 = require("../../../../../components/base/forms/Form");
const Button_1 = require("../../../../../components/base/atoms/Button");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const useClient_1 = require("../../../../../hooks/useClient");
const Delay_1 = require("../../../../../components/base/helpers/Delay");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const errorTypes_1 = require("../../../../../apis/spg/helpers/errorTypes");
const messages = require("../helpers/text");
const Message_1 = require("../../../../../components/base/atoms/Message");
const css = (0, cssComposer_1.default)(styles, "RetailCustomerVerifyAccount");
const RetailCustomerVerifyAccount = ({ retailCustomerDetails, onCompletion }) => {
    var _a;
    const client = (0, useClient_1.useClient)();
    const [error, setError] = (0, react_1.useState)(null);
    const [success, setSuccess] = (0, react_1.useState)(null);
    const onCodeVerificationHandler = (0, react_1.useCallback)((value) => {
        // first, clear error messages (if any were previously set)
        setError(null);
        return client.retailCustomers
            .checkVerificationCode(value.verificationCode, retailCustomerDetails.retailCustomerId)
            .then((session) => {
            onCompletion(session);
        })
            .catch((e) => {
            // first, reset previous messages sent
            setSuccess(null);
            if (e instanceof errorTypes_1.VerificationCodeExpired) {
                setError(messages.verificationCodeExpiredMsg);
            }
            else if (e instanceof errorTypes_1.InvalidVerificationCodeError) {
                setError(messages.verificationCodeNotValidMsg);
            }
            else {
                console.error(e);
                setError(messages.unavailableTryAgainMsg);
            }
        });
    }, [onCompletion]);
    const onResendVerificationCode = async () => {
        try {
            // API call to resend verification code
            await client.retailCustomers.resendVerificationCode(retailCustomerDetails.retailCustomerId);
            setError(null); // clear any eventual errors
            setSuccess(messages.verificationCodeSentMsg);
        }
        catch (e) {
            console.error(e);
            setError(messages.cannotSendNewVerificationCodeMsg);
        }
    };
    return (React.createElement(SlimSection_1.SlimSection, { className: css("center") },
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Verify your Account")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            React.createElement(Form_1.Form, { schema: [
                    {
                        type: "pin",
                        length: 6,
                        minLength: 6,
                        required: true,
                        label: "Verification Code",
                        description: `We've sent a verification code to ${(_a = retailCustomerDetails === null || retailCustomerDetails === void 0 ? void 0 : retailCustomerDetails.mobileNumber) !== null && _a !== void 0 ? _a : "your number"}`,
                        map: "verificationCode"
                    }
                ], onSuccess: onCodeVerificationHandler, disableOnSuccess: false, submitLabel: "Verify" }),
            error && React.createElement("p", { className: css("error") }, error),
            React.createElement(Delay_1.Delay, { secondsToWaitBeforeShow: 20 },
                React.createElement("div", { className: css("center") },
                    React.createElement(Message_1.MessageTitle, null, "Haven't received the code yet?"),
                    React.createElement(Message_1.MessageBody, null,
                        React.createElement(Button_1.Button, { onClick: onResendVerificationCode }, "Request a new code")))),
            success && React.createElement("p", { className: css("success") }, success))));
};
exports.RetailCustomerVerifyAccount = RetailCustomerVerifyAccount;
//# sourceMappingURL=index.js.map